/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MetadataOut } from '../models/MetadataOut';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MetadataService {
    /**
     * Metadata
     * @returns MetadataOut Successful Response
     * @throws ApiError
     */
    public static metadataMetadataGet(): CancelablePromise<MetadataOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metadata',
        });
    }
}
